import { ButtonProps } from './Button.types';

export function Button({
  type = 'button',
  id,
  testId,
  children,
  onClick,
  buttonClassName,
  disabled = false,
}: ButtonProps) {
  return (
    <button
      type={type}
      id={id}
      data-testid={testId}
      className={buttonClassName}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
